
<template>
  <div v-html="compiledMarkdown" class="markdown-body" />
</template>

<script>
import marked from 'marked'
import hljs from 'highlight.js/lib/core'
import jsHighlight from 'highlight.js/lib/languages/javascript'

export default {
	name: 'MarkdownDisplay',
	props: {
		markdown: {
			type: String,
			required: true,
		}
	},
	mounted() {
		hljs.registerLanguage('javascript', jsHighlight)
		hljs.highlightAll()
	},
	computed: {
		compiledMarkdown() {
			return marked(this.markdown, {
				highlight: function(markdown) {
					return hljs.highlightAuto(markdown).value
				}
			})
		}
	}
}
</script>

<style>
@import '~highlight.js/styles/atom-one-dark.css';
.markdown-body > p > img {
  max-width: 90%;
  max-height: 600px;
  display: flex;
  margin: auto;
}
.markdown-body pre code {
	background: #282c34!important;
	padding: 10px;
}
.markdown-body blockquote {
	border-right: 5px #ddd solid;
	padding-right: 10px;
	font-size: 105%;
}
.markdown-body ul {
	padding-right: 15px;
}
</style>